import { render, staticRenderFns } from "./ProductBulkAdd.vue?vue&type=template&id=57e88631&"
import script from "./ProductBulkAdd.vue?vue&type=script&lang=ts&"
export * from "./ProductBulkAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports